import React from "react";
import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';
import TableFooter from './TableFooter.jsx';
import { LogHelper } from 'com-gyf-webcore-loghelper';

/**
 * Funcion que devuelve un componente que representa la tabla contenedora
 * @param {any} props Objeto que contiene todas las propiedades utilizadas por el container
 */
const Table = (props) => {
    //let { tarjetas, cuentaSeleccionada, empresaId, cuentaTarjetaId, limiteCompraEmpresa, limiteCompraCuenta } = props.nuevaData

    let tieneTarjetas = false;
    let nuevaData;
    let empresaSeleccionada;
    let novedadEmpresa;
    let cuentas = [];
    let cuentaSeleccionada;
    let tarjetas = [];
    let novedadCuenta;
    let empresaId;
    let limiteCompraEmpresa;
    let limiteCompraCuenta;
    let empresas = [];
    let cuentaTarjetaId;
    let permisos;
    let limiteCliente;

    if (props.data.empresas.length != 0 && props.data.cuentas.length != 0){
        //Busco la empresa seleccionada por el id
        empresaSeleccionada = props.data.empresas.find((emp) => emp.Id == props.data.empresaId);
        //Si no la encuentro tomo la primera de la lista
        empresaSeleccionada = ((empresaSeleccionada) ? empresaSeleccionada : props.data.empresas[0]);
        //Busco novedades para esa empresa
        novedadEmpresa = props.data.novedadesEmpresas.find(x => x.EmpresaId == empresaSeleccionada.Id);
        //Si existe una novedad tomo el valor del limite de comprar para mostrar
        limiteCompraEmpresa = (novedadEmpresa) ? novedadEmpresa.ValorNovedad : empresaSeleccionada.LimiteCompra;
        //Hago una copia del array de cuentas filtrado por empresa
        cuentas = JSON.parse(JSON.stringify(props.data.cuentas.filter((cue) => (cue.EmpresaId || cue.EmpresaVisaId) == empresaSeleccionada.Id)));
        //Luego busco la cuenta por id, sino existe tomo la primera de la lista
        cuentaSeleccionada = cuentas.find((cue) => cue.Id == props.data.cuentaTarjetaId);
        //Si ésta es undefined quiere decir que la empresa no tiene cuentas.
        cuentaSeleccionada = ((cuentaSeleccionada) ? cuentaSeleccionada : cuentas[0]);
        //Hago nuevamente una copia del array de tarjetas filtrado por la cuenta seleccionada

    
        //Si existe busco las tarjetas asociadas (hago copia para no perderlas) y las novedades de esa cuenta
        if (cuentaSeleccionada) {
            tarjetas = props.data.tarjetas.filter((tar) => {
                return ((cuentaSeleccionada) ? tar.CuentaTarjetaId == cuentaSeleccionada.Id && tar.TieneBaja != "1" : undefined)
            });

            novedadCuenta = props.data.novedadesCuentas.find(x => x.CuentaTarjetaId == cuentaSeleccionada.Id);
            limiteCompraCuenta = (novedadCuenta) ? novedadCuenta.ValorNovedad : cuentaSeleccionada.Valor;

            if (novedadCuenta) {
                const valorNovedadInt = parseInt(novedadCuenta.ValorNovedad, 10);
                const _valorLimiteCompra = props.nuevaData.limiteCompra.find(x => x.Id == valorNovedadInt).Valor;                
                limiteCompraCuenta = _valorLimiteCompra;
            }
        }

        nuevaData = {
            empresas: props.data.empresas,
            empresaSeleccionada,
            empresaId: empresaSeleccionada.Id,
            limiteCompraEmpresa,
            cuentas,
            cuentaSeleccionada,
            cuentaTarjetaId: ((cuentaSeleccionada) ? cuentaSeleccionada.Id : undefined),
            limiteCompraCuenta,
            tarjetas,
            permisos: props.data.functions,
            limiteCliente: props.data.limiteCliente
        }

        tieneTarjetas = true;
    }

    return (
        <div className="bottom-separator-xxs">
            <TableHeader
                limitesCliente={props.limitesCliente} 
                data={props.data}
                empresaId={nuevaData.empresaId}
                cuentaTarjetaId={nuevaData.cuentaTarjetaId}                
                limiteCompraEmpresa={limiteCompraEmpresa}
                limiteCompraCuenta={limiteCompraCuenta}
                cambiarEmpresa={props.cambiarEmpresa}
                cambiarCuenta={props.cambiarCuenta} />

            {cuentaSeleccionada &&
                <div>
                    <hr className="separator-line separator-light" />

                    <TableBody data={props.data}
                        tarjetas={tarjetas}
                        cuentaSeleccionada={cuentaSeleccionada}
                        cambiarLimite={props.cambiarLimite}
                        cambiarModoEdicion={props.cambiarModoEdicion}
                        novedadesTarjetas={props.novedadesTarjetas}
                        mostrarMensajeLimitesIguales={props.mostrarMensajeLimitesIguales}
                        tieneTarjetas={tieneTarjetas}/>

                    <hr className="separator-line separator-light" />

                    <TableFooter data={props.data} cuentaSeleccionada={cuentaSeleccionada} />
                </div>}
        </div>
    );
};


export default Table